// extracted by mini-css-extract-plugin
export default {"wrapper":"Props_wrapper__J9Qzc","fruitcontainer":"Props_fruitcontainer__-EgFx","fruitdiv":"Props_fruitdiv__Uc-E5","fruitImg":"Props_fruitImg__tydkS","heading":"Props_heading__4QfPd"};